window.addEventListener('DOMContentLoaded', () => {
  document.fonts.ready.then(() => {
    document.querySelectorAll('[data-anims]').forEach( anims => {
      anims.querySelectorAll('[data-anim]').forEach(anim => {
        const animType = anim.getAttribute('data-anim');
        if (animType === 'char') {
          anim.st = SplitText.create(anim.querySelectorAll('.__sentence'), {type: 'chars, words', charsClass: 'char', wordsClass: 'word', mask: 'words'});
          gsap.set(anim.st.chars, {yPercent: 120});

        } else if (animType === 'word') {
          anim.st = SplitText.create(anim.querySelectorAll('.__sentence'), {type: 'words, lines', linesClass: 'line', wordsClass: 'word', mask: 'lines'});
          gsap.set(anim.st.words, {yPercent: 120});
        } else if (animType === 'zoomin') {
          gsap.set(anim, {opacity: 0, scale: 1.4});
        } else {
          gsap.set(anim, {opacity: 0, y: '4rem'});
        }

      });
      ScrollTrigger.create({
        trigger: anims,
        start: 'top 80%',
        end: 'top top',
        once: true,
        onEnter: () => {
          const animDelay = anims.getAttribute('data-anims-delay') ? parseFloat(anims.getAttribute('data-anims-delay')) : 0;
          anims.querySelectorAll('[data-anim]').forEach((item, index) => {
            const animType = item.getAttribute('data-anim');
            if (animType === 'char') {
              gsap.set(item, {opacity: 1});
              gsap.to(item.st.chars, {
                yPercent: 0,
                duration: 1,
                ease: Circ.easeOut,
                stagger: 0.03,
                delay: animDelay + 0.2 * index,
                onComplete: () => {
                  item.classList.add('--animated');
                  item.st.revert();
                }
              });
            } else if (animType === 'word') {
              gsap.set(item, {opacity: 1});
              gsap.to(item.st.words, {
                yPercent: 0,
                duration: 1,
                ease: Circ.easeOut,
                stagger: 0.03,
                delay: animDelay + 0.2 * index,
                onComplete: () => {
                  item.classList.add('--animated');
                  item.st.revert();
                }
              });
            } else if ( animType === 'zoomin') {
              gsap.to(item, {
                opacity: 1,
                scale: 1,
                duration: 1.4,
                ease: Circ.easeOut,
                delay: animDelay + 0.2 * index,
                onComplete: () => {
                  gsap.set(item, { clearProps: 'all' });
                  item.classList.add('--animated');
                }
              });
            } else {
              gsap.to(item, {
                opacity: 1,
                y: 0,
                duration: 1.4,
                ease: Circ.easeOut,
                delay: animDelay + 0.2 * index,
                onComplete: () => {
                  gsap.set(item, { clearProps: 'all' });
                  item.classList.add('--animated');
                }
              });
            }
          });
        }
      });
    });
  });
});
